import Toastify from 'toastify-js';

function loadMoreNews() {
    var self = $(this);
    self.addClass('loading');

    var url =
        self.data('url') +
        '?page=' +
        $(this).data('nextPage') +
        '&tagId=' +
        $(this).data('tagId') +
        '&perPage=' +
        $(this).data('perPage');

    if ($)
        $.ajax({
            type: 'GET',
            url,
            success: function (data) {
                self.data('nextPage', data.next_page_url ? data.current_page + 1 : data.current_page);
                data.data.map(function (v) {
                    var item = $('.list-news .card-news').first().clone();
                    item.find('.t-image').attr('src', v.thumb).attr('alt', v.title);
                    item.find('.t-tag').html(v.tag.name).attr('href', v.tag.url);
                    item.find('.t-title').html(v.title);
                    item.find('.t-resume').html(v.resume);
                    item.find('.t-footer').html(v.created_at_formatted + (v.city_state ? ' - ' + v.city_state : ""));
                    item.find('.t-url').attr('href', v.url).attr('alt', v.title);
                    $('.list-news .grid').append(item);
                });

                if (!data.next_page_url) {
                    self.addClass('hidden');
                }

                self.removeClass('loading');
            },
            error: function (data) {
                Toastify({
                    text: 'Houve um erro, tente novamente.',
                    duration: 1500,
                    newWindow: true,
                    close: true,
                    gravity: 'top',
                    position: 'center',
                    stopOnFocus: true,
                    style: {
                        background: 'linear-gradient(135deg, #FF9441, #F36F21)',
                    },
                    onClick: function () {},
                }).showToast();

                self.removeClass('loading');
            },
        });
}

function initialize() {
    $('.list-news .btn-load-more').on('click', loadMoreNews);
}

initialize();
